"use strict";
/**
 * Method follows path.extname() implementation
 * path.extname() is not used due to using library on React Native would require additional dependencies.
 **/
Object.defineProperty(exports, "__esModule", { value: true });
var extractFileExtension = function (fileName) {
    if (!fileName)
        return '';
    var tokens = fileName.split('.');
    if (tokens.length > 2) {
        return "." + tokens[tokens.length - 1];
    }
    if (tokens.length == 2) {
        var left = tokens[0], right = tokens[1];
        // File with name but no extension
        if (!left && right) {
            return '';
        }
        // Dot files
        if (left && !right) {
            return '.';
        }
        return "." + tokens[tokens.length - 1];
    }
    return '';
};
exports.default = extractFileExtension;
//# sourceMappingURL=extractFileExtension.js.map